import React, { createContext, useCallback, useContext, useState } from 'react';

type ApplicationFullName = { firstName: string | undefined; lastName: string | undefined } | undefined;
type SetApplicationFullName = (fullName: ApplicationFullName) => void;

const ApplicationUpdateFullNameContext = createContext<SetApplicationFullName>(() => undefined);
const ApplicationFullNameContext = createContext<ApplicationFullName>(undefined);

export const JobApplicationFullNameProvider: React.FC = ({ children }) => {
  const [fullName, setFullName] = useState<ApplicationFullName>(undefined);

  const setApplicationFullName = useCallback((firstNameLastNameObject: ApplicationFullName): void => {
    setFullName(firstNameLastNameObject);
  }, []);

  return (
    <ApplicationUpdateFullNameContext.Provider value={setApplicationFullName}>
      <ApplicationFullNameContext.Provider value={fullName}>{children}</ApplicationFullNameContext.Provider>
    </ApplicationUpdateFullNameContext.Provider>
  );
};

export const useSetApplicationFullName = (): SetApplicationFullName => {
  return useContext(ApplicationUpdateFullNameContext);
};

export const useApplicationFullName = (): ApplicationFullName => {
  return useContext(ApplicationFullNameContext);
};
